export const design = {
  'colors': {
    'light': '#FFF',
    'dark': '#222222',
    'blue': '#381DDB',
    'lightRed': '#FFA3A3',
    'red': '#FC5252',
    'pink': '#C00096',
    'cian': '#84C4FF',
  },

  'fonts': {
    'Headline': "'Montserrat' ,",
    'body': "'Raleway' ,"
  }
}